import { useQuery } from "@tanstack/react-query";
import type { FruitImage } from "../hooks/useFruitImages";
import { getActiveSession, sessionPhotosForTarget } from "./sessionManager";

export function useOfflineFruitImages(
    tenantId: string | undefined,
    checkId: number | undefined,
) {
    return useQuery({
        networkMode: "always",
        queryKey: ["offlineFruitImages", tenantId, checkId],
        enabled: !!tenantId && !!checkId,
        queryFn: async (): Promise<Record<number, FruitImage[]>> => {
            const session = await getActiveSession();
            if (!session) {
                return {};
            }

            return Object.fromEntries(
                session.photos
                    .filter((photo) => photo.target === "fruit")
                    .map((photo) => photo.target_temp_id)
                    .filter((id, index, ids) => ids.indexOf(id) === index)
                    .map((fruitId) => [fruitId, sessionPhotosForTarget(session, "fruit", fruitId)])
            );
        },
    });
}
